export enum AnalyticsActionType {
  GET_MCI_REPORT_URL_FAILURE = '@@analytics/GET_MCI_REPORT_URL_FAILURE',
  GET_MCI_REPORT_URL_REQUEST = '@@analytics/GET_MCI_REPORT_URL_REQUEST',
  GET_MCI_REPORT_URL_SUCCESS = '@@analytics/GET_MCI_REPORT_URL_SUCCESS',

  GET_SUPPLY_SUMMARIES_FAILURE = '@@analytics/GET_SUPPLY_SUMMARIES_FAILURE',
  GET_SUPPLY_SUMMARIES_REQUEST = '@@analytics/GET_SUPPLY_SUMMARIES_REQUEST',
  GET_SUPPLY_SUMMARIES_SUCCESS = '@@analytics/GET_SUPPLY_SUMMARIES_SUCCESS',

  IS_LOADING_MCI_REPORTS = '@@analytics/IS_LOADING_MCI_REPORTS',

  SET_SUPPLY_SUMMARY_DATE_RANGE_FILTER = '@@analytics/SET_SUPPLY_SUMMARY_DATE_RANGE_FILTER',
}
